import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	filters: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.filters.filters',
		defaultMessage: 'Filters',
		description: 'Section title for filters',
	},
});
